import { IMyWindow } from '@lab-photos/app/shared/interfaces/my-window.interface';
import { isString } from 'lodash/index';

/**
 * @description
 * Used to define the Google Analytics preview
 * Based on the environments variable injection in the index file
 * @param {IMyWindow} window The window object containing possibly the "googleAnalyticsPreview" variable
 * @returns {string} Return the Google Analytics preview ID if it exists or null otherwise
 */
export function googleAnalyticsPreviewFactory(window: IMyWindow): string | null {
  const { googleAnalyticsPreview } = window;

  if (isString(googleAnalyticsPreview)) {
    return googleAnalyticsPreview;
  }

  return null;
}
